// Общие хелперы админ-консоли: лимиты токенов, формат ошибок API, кэш категорий.
// Выделено из admin.ts (аудит, этап 2 — декомпозиция).
import { state } from '../shared/state';
import type { CategoryData } from '../shared/types';

export const TOKEN_LIMIT_MIN = 1024;
export const TOKEN_LIMIT_STEP = 1024;

export interface ApiErrorBody {
  errors?: Array<{ message?: string }>;
  detail?: string;
  error?: { message?: string };
  message?: string;
}

export function formatApiErrors(data: ApiErrorBody | null | undefined, fallback = 'Ошибка') {
  if (data?.errors && data.errors.length > 0) {
    const messages = data.errors.map(err => err.message).filter(Boolean);
    if (messages.length > 0) return [...new Set(messages)].join('; ');
  }
  return data?.detail || data?.error?.message || data?.message || fallback;
}

let adminCategoriesCache: Record<string, CategoryData> = {};

export function setAdminCategoriesCache(cats: Record<string, CategoryData>) {
  adminCategoriesCache = cats;
}

// normalizeTokenLimitMax / normalizeTokenLimitValue убраны вместе с формой
// персональных токенных лимитов пользователя: других потребителей у них не было.

export async function getAdminCategories() {
  try {
    const r = await fetch('/api/admin/categories', { headers: { 'Authorization': 'Bearer ' + state.authToken } });
    if (!r.ok) {
      const data = await r.json().catch(() => ({})) as ApiErrorBody;
      throw new Error(formatApiErrors(data, 'Не удалось загрузить категории'));
    }
    adminCategoriesCache = await r.json();
    return adminCategoriesCache;
  } catch (e) {
    if (Object.keys(adminCategoriesCache).length > 0) return adminCategoriesCache;
    if (state.categories && Object.keys(state.categories).length > 0) return state.categories;
    throw e;
  }
}
